export interface WkGenericTypeInterface {
  [key: string]: string;
}

export interface WkTemplateFormRequest {
  name: string;
  nodeType?: string;
  properties: WkGenericTypeInterface;
}

export interface WkTemplate {
  name: string;
  id: string;
  title?: string;
}

interface WKPeopleApiGroupEntry {
  isRoot: boolean;
  displayName: string;
  id: string;
}

interface WKPeopleApiGroupEntries {
  entry: WKPeopleApiGroupEntry;
}

interface WKUserGroupAPISubInterface {
  pagination: {};
  entries: WKPeopleApiGroupEntries[];
}
export interface WKUserGroupAPI {
  list: WKUserGroupAPISubInterface;
}
